export default "__VITE_ASSET__DMY6hYhA__"